import get from "../../../../utils/GetNested";

export const sortRows = (rows: any[], columnId: string | null, direction: "asc" | "desc" | null) => {
	if (!columnId || !direction) {
		return rows;
	}

	return rows.sort((rowA, rowB) => {
		const rowAValue =
			columnId === "name" ? rowA.name.toLowerCase() : get(rowA, ["data_fields", columnId, "value", "name"], "");
		const rowBValue =
			columnId === "name" ? rowB.name.toLowerCase() : get(rowB, ["data_fields", columnId, "value", "name"], "");

		if (direction === "asc") {
			if (rowAValue < rowBValue) {
				return -1;
			}
			if (rowAValue > rowBValue) {
				return 1;
			}
			return 0;
		}

		if (rowAValue > rowBValue) {
			return -1;
		}
		if (rowAValue < rowBValue) {
			return 1;
		}
		return 0;
	});
};
